export default __webpack_public_path__ + "static/media/i-financeiro.04bd26bb.png";